import { useCallback, useState } from 'react';
import { createMMKV } from 'react-native-mmkv';

// ─────────────────────────────────────────────────────────────────────────────

export const useGroupOrderIntroState = (params: Params) => {
  const { onComplete, onShow } = params;

  // ─── State ───────────────────────────────────────────────────────────

  const [visible, setVisible] = useState(false);

  // ─── Handlers ────────────────────────────────────────────────────────

  const show = useCallback(() => {
    const hasSeen = STORAGE.getBoolean(HAS_SEEN_INTRO_KEY) ?? false;

    if (hasSeen) {
      onComplete();
      return;
    }

    setVisible(true);
    onShow?.();
  }, [onComplete, onShow]);

  const dismiss = useCallback(() => {
    setVisible(false);

    STORAGE.set(HAS_SEEN_INTRO_KEY, true);
  }, []);

  const hide = useCallback(() => {
    dismiss();
    onComplete();
  }, [dismiss, onComplete]);

  // ─────────────────────────────────────────────────────────────────────

  return {
    visible,
    show,
    hide,
    dismiss,
  };
};

// ─────────────────────────────────────────────────────────────────────────────

const STORAGE = createMMKV({ id: 'sg.group-order' });
const HAS_SEEN_INTRO_KEY = 'has-seen-group-order-intro';

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  onComplete: () => void;
  onShow?: () => void;
};
